import { render, staticRenderFns } from "./_Header.vue?vue&type=template&id=21b1e8c1&scoped=true&"
import script from "./_Header.vue?vue&type=script&lang=js&"
export * from "./_Header.vue?vue&type=script&lang=js&"
import style0 from "./_Header.vue?vue&type=style&index=0&id=21b1e8c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b1e8c1",
  null
  
)

export default component.exports